import React from 'react';
import { useEditorContext } from '../../Editor/Context';
import SelectionBubbleMenu from '../SelectionBubbleMenu';
import cn from 'classnames';
import Link from '../buttons/Link';
import { LinkMenuState } from '../../../extensions/extension-link-menu-handler/linkMenuHandler';
const GroupAboutBubbleMenu = ({ scrollContainerRef })=>{
    const editor = useEditorContext();
    if (!editor) {
        return null;
    }
    if (!(editor === null || editor === void 0 ? void 0 : editor.isEditable)) {
        return null;
    }
    const buttonCount = 1;
    const handlerStorage = editor.storage.linkBubbleMenuHandler;
    const menuState = handlerStorage.state;
    let workaroundLinkBubble = false;
    if (menuState === LinkMenuState.VIEW_LINK_DETAILS) {
        workaroundLinkBubble = true;
        return null;
    }
    return /*#__PURE__*/ React.createElement(SelectionBubbleMenu, {
        scrollContainerRef: scrollContainerRef,
        menuHeight: 38,
        menuWidth: 40 * buttonCount,
        editor: editor,
        open: !editor.state.selection.empty,
        forceBelowSelection: workaroundLinkBubble
    }, /*#__PURE__*/ React.createElement("div", {
        className: cn('ds-surface-tertiary'),
        style: {
            maxWidth: '100vw',
            display: 'flex',
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ React.createElement(Link, {
        editor: editor
    })));
};
GroupAboutBubbleMenu.displayName = 'GroupAboutBubbleMenu';
export default GroupAboutBubbleMenu;

//# sourceMappingURL=GroupAboutBubbleMenu.js.map